import React, { useRef } from 'react';
import { Box, Grid, Typography } from '@mui/material';
import EventSeatIcon from '@mui/icons-material/EventSeat';
import { AutoSizer, List } from 'react-virtualized';

const SearchPNRDetails = ({ reportData = [] }) => {
    const listRef = useRef(null);

    const rowRenderer = ({ index, key, style }) => {
        const obj = reportData[index];
        if (!obj) return null;

        return (
            <Box key={key} style={style} sx={{ borderBottom: '1px solid lightgray' }}>
                <Box sx={{ padding: '10px 16px' }}>
                    <Typography sx={{ fontSize: '13px', padding: '4px 0px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        {`${obj?.BookingID}-${obj?.TicketNo}`}
                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                            {obj?.SeatNos}
                            <EventSeatIcon sx={{ color: '#757575', marginLeft: '4px', fontSize: '18px' }} />
                        </Box>
                    </Typography>
                    <Typography sx={{ fontSize: '14px', padding: '4px 0px' }}>
                        {obj?.SubRouteName}
                    </Typography>
                    <Typography sx={{ fontSize: '14px', padding: '4px 0px' }}>
                        {obj?.BookingDateFormated}
                    </Typography>

                    <Box sx={{ paddingTop: '8px' }}>
                        {[
                            { label: 'FARE', value: `Rs. ${obj?.allSeatFare || 0}` },
                            { label: 'TAX', value: `Rs. ${obj?.allSeatServiceTax || 0}` },
                            { label: 'PICKUP CHARGE', value: `Rs. ${obj?.allSeatPickupCharge || 0}` },
                            { label: 'DROPOFF CHARGE', value: `Rs. ${obj?.allSeatDropoffCharge || 0}` }
                        ].map((item, idx) => (
                            <Grid container key={idx} sx={{ fontSize: '14px', padding: '4px 0px' }}>
                                <Grid item xs={6}>
                                    <Typography sx={{ fontSize: '11px', color: '#0086ff', fontWeight: '600' }}>
                                        {item.label}
                                    </Typography>
                                </Grid>
                                <Grid item xs={6} sx={{ textAlign: 'right' }}>
                                    <Typography sx={{ fontSize: '14px' }}>
                                        {item.value}
                                    </Typography>
                                </Grid>
                            </Grid>
                        ))}
                    </Box>
                </Box>
            </Box>
        );
    };

    return (
        <Box sx={{ width: '100%', height: 'calc(100vh - 110px)' }}>
            <AutoSizer>
                {({ height, width }) => (
                    <List
                        key={JSON.stringify(reportData)}
                        ref={listRef}
                        width={width}
                        height={height}
                        rowCount={reportData.length}
                        rowHeight={230}
                        rowRenderer={rowRenderer}
                        overscanRowCount={5}
                        style={{ overflowX: 'hidden' }}
                    />
                )}
            </AutoSizer>
        </Box>
    );
};

export default SearchPNRDetails;
